import { render } from "./tax-section.vue?vue&type=template&id=38cbb451&ts=true"
import script from "./tax-section.vue?vue&type=script&lang=ts"
export * from "./tax-section.vue?vue&type=script&lang=ts"

import "./tax-section.vue?vue&type=style&index=0&id=38cbb451&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__